import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
export const StyledLabel = styled.label `
  font-family: 'Segoe UI Semibold';
  color: #2b2828;
  font-size: 16px;
`;
//# sourceMappingURL=index.js.map